import React from 'react';

import {
  ListItemText,
  IconButton,
  Link,
  Tooltip,
  ListItemSecondaryAction,
  LaunchIcon,
} from '@gogame/components';

export const ConversionPageOption = ({ name, url }) => {
  const handleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div style={{ paddingRight: 48, minWidth: 0 }}>
      <Tooltip title={name} wrapper wrapperComponent={'div'}>
        <ListItemText
          primary={name}
          primaryTypographyProps={{ noWrap: true }}
        />
      </Tooltip>
      <ListItemSecondaryAction>
        <IconButton
          icon={<LaunchIcon />}
          component={Link}
          href={url}
          target={'_blank'}
          color={'primary'}
          tooltip={'Open'}
          onClick={handleClick}
        />
      </ListItemSecondaryAction>
    </div>
  );
};
